import clsx from "clsx";

import heroBackground from "@assets/mmm/hero-bg.svg";
import insight1 from "@assets/mmm/mmm-insight-1.svg";
import insight2 from "@assets/mmm/mmm-insight-2.svg";
import insight3 from "@assets/mmm/mmm-insight-3.svg";

export const LandingPage = () => {
  return (
    <div>
      <div className="bg-interstellar text-white flex items-center justify-between px-6 py-[20px]">
        <div className="flex items-center gap-3">
          <h3 className="text-xl m-0 font-bold">Introducing MMM+.</h3>
          <p className="text-xl font-light m-0">
            Media mix modeling, reimagined for modern commerce
          </p>
        </div>
        <div className="flex items-center gap-8">
          <a
            href="https://www.northbeam.io/mmm-plus"
            rel="noopener noreferrer"
            target="_blank"
            className="text-xs text-nebula text-decoration-none hover:text-cosmic"
          >
            LEARN MORE
          </a>
          <a
            href="https://www.northbeam.io/mmm-demo"
            rel="noopener noreferrer"
            target="_blank"
            className={clsx(
              "button sm primary-button font-bold text-interstellar bg-nebula hover:bg-cosmic",
              "text-decoration-none",
            )}
          >
            BOOK A DEMO
          </a>
        </div>
      </div>
      <div
        className={clsx(
          "bg-interstellar rounded-lg mx-6 mt-6 mb-24 pt-16 px-16 pb-14 text-white",
          "flex items-start justify-around gap-8 bg-right-bottom bg-no-repeat text-center",
        )}
        style={{ backgroundImage: `url(${heroBackground})` }}
      >
        <div className="max-w-[850px] flex flex-col items-center">
          <h1 className="text-[42px] leading-[56px] mb-7 mt-2">
            You’re already data driven. Realize the full potential of your
            marketing budget.
          </h1>
          <p className="text-xl font-light leading-8">
            Forecast revenue and optimize your budget across online and offline
            channels.
          </p>
          <p className="text-xl font-light leading-8 max-w-[600px]">
            Unlock more incremental profit with less budget.
          </p>
          <a
            href="https://www.northbeam.io/mmm-demo"
            rel="noopener noreferrer"
            target="_blank"
            className={clsx(
              "button lg rounded-full mt-2 primary-button font-bold text-interstellar bg-nebula hover:bg-cosmic px-8",
              "text-decoration-none",
            )}
          >
            REQUEST AN MMM+ DEMO
          </a>
          <p className="text-md font-light leading-8 max-w-[600px] mt-12">
            *Minimum annual marketing spend for MMM+ is $6M ($500k per month)
          </p>
        </div>
      </div>
      <h2 className="mx-6 mb-10 font-bold text-4xl flex items-center justify-center">
        Insights to plan and track every marketing decision.
      </h2>
      <div className="flex items-start justify-center gap-12 mx-6 mb-28 text-center">
        <div className="w-[370px]">
          <div
            className={clsx(
              "bg-v2-primary border border-gray-2 rounded rounded-md p-14 mb-5 h-[360px]",
              "flex items-center justify-center",
            )}
          >
            <img className="w-full h-full" alt="mmm-insight-1" src={insight1} />
          </div>
          <h4 className="text-lg font-bold mb-0">
            Discover your ideal budget.
          </h4>
          <p className="text-lg mx-4">
            Give Northbeam your budget range and spend constraints and we’ll
            generate budgets to meet your marketing goals
          </p>
        </div>
        <div className="w-[370px]">
          <div
            className={clsx(
              "bg-v2-primary border border-gray-2 rounded rounded-md p-7 mb-5 h-[360px]",
              "flex items-center justify-center",
            )}
          >
            <img className="w-full h-full" alt="mmm-insight-2" src={insight2} />
          </div>
          <h4 className="text-lg font-bold mb-0">
            Understand your Incremental ROAS/CAC.
          </h4>
          <p className="text-lg mx-4">
            Maximise your channels performance with an understanding of your
            channels incremental impact on performance.
          </p>
        </div>
        <div className="w-[370px]">
          <div
            className={clsx(
              "bg-v2-primary border border-gray-2 rounded rounded-md p-7 mb-5 h-[360px]",
              "flex items-center justify-center",
            )}
          >
            <img className="w-full h-full" alt="mmm-insight-3" src={insight3} />
          </div>
          <h4 className="text-lg font-bold mb-0">
            Track performance, hit spend targets.
          </h4>
          <p className="text-lg mx-4">
            Get a spending plan that helps you meet your marketing goals. Real
            time tracking to the predicted outcome.
          </p>
        </div>
      </div>
      <div className="bg-interstellar py-12 text-center">
        <div className="flex items-center justify-center gap-10">
          <a
            href="https://www.northbeam.io/mmm-plus"
            rel="noopener noreferrer"
            target="_blank"
            className={clsx(
              "text-[18px] text-nebula font-bold rounded rounded-full border border-nebula",
              "hover:border-cosmic hover:text-cosmic px-6 pt-[10px] pb-[9px]",
              "text-decoration-none",
            )}
          >
            LEARN MORE
          </a>
          <a
            href="https://www.northbeam.io/mmm-demo"
            rel="noopener noreferrer"
            target="_blank"
            className={clsx(
              "button sm primary-button font-bold text-interstellar bg-nebula hover:bg-cosmic",
              "text-decoration-none text-[18px] px-6 py-[14px] rounded-full",
            )}
          >
            BOOK A DEMO
          </a>
        </div>
      </div>
    </div>
  );
};
